import { z } from 'zod';

const ALLOWED_CHARACTERS = /^[a-zA-Z0-9\u0E00-\u0E3A\u0E40-\u0E4E_:,()[\]\s-]+$/;
const ALLOWED_CHARACTERS_ERROR_MESSAGE =
  'ใช้ได้เฉพาะตัวอักษร ตัวเลข และอักขระพิเศษ _ : , ( ) [ ] - เท่านั้น';

const UUID = z.string().uuid();

const SelectionId = z.preprocess((val) => {
  if (typeof val === 'string') return val;
  if (val && typeof val === 'object' && 'value' in (val as Record<string, unknown>)) {
    return (val as { value: unknown }).value;
  }
  return val;
}, UUID);

export const ExamLocationRequestFormSchema = z
  .object({
    provinceId: SelectionId,
    locationId: SelectionId.nullable(),
    locationNameTh: z
      .string()
      .regex(ALLOWED_CHARACTERS, ALLOWED_CHARACTERS_ERROR_MESSAGE)
      .nullable(),
    locationNameEn: z
      .string()
      .refine((val) => val === '' || ALLOWED_CHARACTERS.test(val), {
        message: ALLOWED_CHARACTERS_ERROR_MESSAGE,
      })
      .nullable(),
    // Must be null when locationId is null (enforced in superRefine below)
    buildingId: SelectionId.nullable(),
    buildingName: z.string().regex(ALLOWED_CHARACTERS, ALLOWED_CHARACTERS_ERROR_MESSAGE).nullable(),
  })
  .superRefine((data, ctx) => {
    const { provinceId, locationId, locationNameTh, buildingId, buildingName } = data;

    if (!provinceId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['provinceId'],
        message: 'กรุณาเลือกจังหวัด',
      });
    }

    // At least one of locationId / locationNameTh
    if (locationId == null && !locationNameTh) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['locationId'],
        message: 'กรุณาเลือกสถานที่หรือหน่วยงาน (ภาษาไทย)',
      });
      if (!locationNameTh) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['locationNameTh'],
          message: 'กรุณากรอกสถานที่หรือหน่วยงาน (ภาษาไทย)',
        });
      }
    }

    if (locationId === null && buildingId !== null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['buildingId'],
        message: 'buildingId must be null when locationId is null.',
      });
    }

    if (buildingId == null && !buildingName) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['buildingId'],
        message: 'กรุณาเลือกอาคาร',
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['buildingName'],
        message: 'กรุณากรอกอาคาร',
      });
    }
  });

export type ExamLocationRequestFormInputs = z.infer<typeof ExamLocationRequestFormSchema>;
